'use client';

import { use } from 'react';
import AppLayout from '@/components/AppLayout';
import LocalDetailContent from './components/LocalDetailContent';

export default function LocalDetailPage({ params }: { params: Promise<{ id: string }> }) {
  const { id } = use(params);
  return (
    <AppLayout currentPath="/locaux">
      <LocalDetailContent id={id} />
    </AppLayout>
  );
}
